import 'css-chunksrc/client/pages/projectPage/wbsPage/exportButton/styles.scss';export default {
  "exportButton": "_exportButton_1uvyf_1",
  "text": "_text_1uvyf_17",
  "icon": "_icon_1uvyf_21"
};